import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";

import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addStatusOfItemsCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const statusOfItemsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "statusOfItemsComponent",
      title: "",
      description: "",
      labels: ["donutChart", "chart", "status"],
    },
  });

  statusOfItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "statusOfItemsComponent",
      labels: ["donutChart", "chart", "status"],
      description: getCardCopy(language, "statusOfItems").description,
      title: getCardCopy(language, "statusOfItems").title,
    };
  });
  statusOfItemsComponent.mapState(({ dashboard, settings, language }) => {
    const statusCounts = dashboard?._calculated?.statusCounts ?? {};
    const data = (settings?.configuration?.statusDefinition ?? []).map(
      (entry) => {
        return {
          label: entry.name ?? "",
          value: getDropdownCount(statusCounts, entry),
          color: entry.color ?? "",
        };
      }
    );

    return {
      title: getCardCopy(language, "statusOfItems").title,
      description: getCardCopy(language, "statusOfItems").description,
      icon: "DonutLarge",
      data,
    };
  });

  statusOfItemsComponent.mapVisibility(({ settings }) => {
    return (
      isFieldEnabled(settings, "status", "itemReporting") &&
      (settings?.configuration?.statusReportingLevel ?? "overall") === "overall"
    );
  });
}
